export default __webpack_public_path__ + "static/media/audio2.b95f6d66.vtt";